import { isImmutable } from 'immutable';
import isEmpty from 'lodash/isEmpty';
import forEach from 'lodash/forEach';
import get from 'lodash/get';
import { Store } from 'cw-ui-core';
import { appRoles, PERMISSIONS } from 'src/constants';
import { EDIT_PRODUCT_DRAWER } from 'src/features/users/constants/drawerConstants';
import { ADD_EXTERNAL_IDP, EDIT_IDENTITY_PROVIDER_DRAWER } from 'src/features/authentication-v2/constants';

export const toArray = reduxData => (reduxData && isImmutable(reduxData) ? reduxData.toJS() : []);
export const toMap = reduxData => (reduxData && isImmutable(reduxData) ? reduxData.toJS() : {});

export const emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const isNullOrEmpty = value => value == null || value === '';

export const createQueryParams = (params = {}) => {
    const query = [];
    const paramKeys = Object.keys(params);
    forEach(paramKeys, key => {
        query.push(`${key}=${get(params, `${key}`)}`);
    });
    const queryParams = query.join('&');
    return queryParams;
};

export const formatErrorMessage = errors => {
    const result = [];
    forEach(errors, error => {
        // removing the special characters from the error message.
        result.push(error.replace(/[{()}:"[\]]/g, ''));
    });
    return result;
};

export const checkUserForFullAuthorization = () => {
    const state = Store().getState();

    let userRoles = toArray(state.oidc.getIn(['user', 'profile', 'app_role_assignments']));
    let userRolesFromParentAccount = toArray(state.oidc.getIn(['user', 'profile', 'origin_app_role_assignments']));

    userRoles = Array.isArray(userRoles) ? userRoles : [userRoles];
    const userRoleIds = userRoles.map(role => role.appRoleId);
    // Added for Vodafone use case
    userRolesFromParentAccount = Array.isArray(userRolesFromParentAccount)
        ? userRolesFromParentAccount
        : [userRolesFromParentAccount];

    const userRoleIdsFromParent = userRolesFromParentAccount.map(role => role.appRoleId);

    let isAuthorized = false;

    if (!isEmpty(userRoleIds) || !isEmpty(userRoleIdsFromParent)) {
        isAuthorized =
            userRoleIds.includes(appRoles.ADMIN) ||
            userRoleIds.includes(appRoles.USER_MANAGEMENT) ||
            userRoleIds.includes(appRoles.FULL_ADMIN) ||
            userRoleIdsFromParent.includes(appRoles.ADMIN);
    }

    return isAuthorized;
};

export const doUserHaveFullUserManagmentAccess = () => {
    const state = Store().getState();
    const permissions = toArray(state.oidc.getIn(['user', 'profile', 'permissions']));
    const hasAccess = checkUserForFullAuthorization() || !isEmpty(permissions);

    return hasAccess;
};

export const checkIfUserHaveGivenPermissions = (requiredPermissions = [], allowIfAnyOneOfPermissionPresent = false) => {
    if (checkUserForFullAuthorization()) {
        return true;
    }
    const availiablePermissions = toArray(Store().getState().oidc.getIn(['user', 'profile', 'permissions']));
    let hasPermissions = false;

    if (allowIfAnyOneOfPermissionPresent) {
        hasPermissions = requiredPermissions.some(permission => availiablePermissions.includes(permission));
    } else {
        hasPermissions = requiredPermissions.every(permission => availiablePermissions.includes(permission));
    }
    return hasPermissions;
};

export const shouldDisableUserDetails = screenKey => {
    const isViewAvailiable = checkIfUserHaveGivenPermissions([PERMISSIONS.USERS_VIEW]);
    const isUpdateAvailiable = checkIfUserHaveGivenPermissions([PERMISSIONS.USERS_UPDATE]);

    if (screenKey === EDIT_IDENTITY_PROVIDER_DRAWER || screenKey === EDIT_PRODUCT_DRAWER) {
        const isViewAuthAvailiable = checkIfUserHaveGivenPermissions([PERMISSIONS.USERS_AUTH_VIEW]);
        const isUpdateAuthAvailiable = checkIfUserHaveGivenPermissions([PERMISSIONS.USERS_AUTH_UPDATE]);

        if (isUpdateAuthAvailiable && isViewAvailiable) {
            return false;
        }
        if (isViewAuthAvailiable && isViewAvailiable) {
            return true;
        }
        return false;
    }
    if (screenKey === ADD_EXTERNAL_IDP && isViewAvailiable) {
        return false;
    }

    if (isUpdateAvailiable) {
        return false;
    }
    if (isViewAvailiable) {
        return true;
    }
    return false;
};
export const handleNoUserPermissionsPresent = screenKey => {
    const isViewAvailiable = checkIfUserHaveGivenPermissions([PERMISSIONS.USERS_VIEW]);
    const isUpdateAvailiable = checkIfUserHaveGivenPermissions([PERMISSIONS.USERS_UPDATE]);
    let isNeitherAvailiable = !(isViewAvailiable || isUpdateAvailiable);
    if ((screenKey === EDIT_IDENTITY_PROVIDER_DRAWER || screenKey === EDIT_PRODUCT_DRAWER) && !isNeitherAvailiable) {
        const isViewAuthAvailiable = checkIfUserHaveGivenPermissions([PERMISSIONS.USERS_AUTH_VIEW]);
        const isUpdateAuthAvailiable = checkIfUserHaveGivenPermissions([PERMISSIONS.USERS_AUTH_UPDATE]);
        isNeitherAvailiable = !(isViewAuthAvailiable || isUpdateAuthAvailiable);
    }
    return isNeitherAvailiable;
};
